import styled from "styled-components";

export const FormContainer = styled.div`
	height: 150px;
	display: contents;
	.label-title {
	}
	.form {
		padding: 20px;
	}
	.text-area::placeholder{
		font-size: 0.875rem;
	}
	.custom-input::placeholder{
		font-size: 0.875rem;
	}
	.custom-input{
		font-size: 0.875rem;
	}
	.error {
		.css-13cymwt-control {
			border-color: #ae1515;
		}
		color: #ae1515;
		&.text-area {
			border: 1px solid #ae1515;
			border-radius: 5px;

		}
	}
	.form-content-slt {
		z-index: 999;
		position: relative;
		width: 100%;
		max-width: 670px;
		flex: 1;
	}
	.form-content {
		position: relative;
		width: 100%;
		max-width: 670px;
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex: 1;
	}
	.form-content label{
		gap:10px;
	}
	.Exper-add-new {
		display: flex;
		padding-bottom: 5px;
	}
	.exper-title {
		flex: 1;
	}
	.exper-btn {
		display: flex; /* Use flexbox for easy alignment */
		justify-content: flex-end; /* Align children to the end (right side) */
	}
	.text-area {
		min-height: 100px;
		max-height: 140px;
		font-size: 0.875rem;
	}
	.label-container{
		gap: 10xp;
	}
	.label-title{
		font-weight: 800;
	}
	.label-title-second {
		color: #666666;
		padding: 5px 0px;
	}
	.custom-select{
		padding-top: 10px;
	}
`;

export const Div = styled.div``;
